import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Stack } from '@mui/material';
import { useContext } from 'react';
import { DialogWrapper } from '../../../../../../components/common/DiaglogWrapper';
import { EntityProgrammeContext } from '../Reducers/ProgrammeReducer';
import { ItemConflictsRecordView } from './ConflictRecord';
export const ConflictsPopup = ({ itemConflictRecords }) => {
    const [{ ipData }, dispatch] = useContext(EntityProgrammeContext);
    const setClosed = () => {
        const action = {
            type: 'ClearConfictRecords',
            value: null,
        };
        dispatch(action);
        console.log(`ConflictsPopup dispatchig clear conflict report action`, action);
    };
    return (_jsx(DialogWrapper, { header: 'Conflicts',
        open: itemConflictRecords !== null,
        setClosed, children: itemConflictRecords ? (_jsxs(Stack, { direction: 'column', width: '100%', children: [Object.values(itemConflictRecords).map((conflictRecord, i) => (_jsx(ItemConflictsRecordView, { conflictRecord, ipData }, `${conflictRecord.item.sk}`))) ?? null, _jsx(Stack, { direction: 'row', children: _jsx(Button, { variant: 'contained', onClick: setClosed, children: "OK" }) })] })) : (_jsx(_Fragment, {})) }));
};
